"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedPeerHello =
/*#__PURE__*/
function (_pb_1$PeerHello) {
  _inherits(ExtendedPeerHello, _pb_1$PeerHello);

  function ExtendedPeerHello(properties) {
    var _this;

    _classCallCheck(this, ExtendedPeerHello);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedPeerHello).call(this, properties));
    _this.type = ExtendedPeerHello.type;
    return _this;
  }

  _createClass(ExtendedPeerHello, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedPeerHello.context, "/").concat(this.sesid).concat(ExtendedPeerHello.suffix);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.PeerHello.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      mqttMessage.retained = true;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedPeerHello(pb_1.PeerHello.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedPeerHello;
}(pb_1.PeerHello);

ExtendedPeerHello.type = "PeerHello";
ExtendedPeerHello.context = "/peer";
ExtendedPeerHello.suffix = "/handshake";
exports.PeerHello = ExtendedPeerHello;